module.exports = __webpack_public_path__ + "static/media/phone-verification.0e12289b.png";